import CourseRegisterModal from './CourseRegisterModal';

export { CourseRegisterModal };
export default CourseRegisterModal;
